const executiveLocalesAndNewsboards = {
  FASHIONUNITED_BE: 'nl-BE',
  FASHIONUNITED_BE_FR: 'fr-BE',
  FASHIONUNITED_CA: 'en-CA',
  FASHIONUNITED_CA_FR: 'fr-CA',
  FASHIONUNITED_CH: 'de-CH',
  FASHIONUNITED_CL: 'es-CL',
  FASHIONUNITED_CO: 'es-CO',
  FASHIONUNITED_COM: 'en-US',
  FASHIONUNITED_COM_AR: 'es-AR',
  FASHIONUNITED_COM_BR: 'pt-BR',
  FASHIONUNITED_COM_PE: 'es-PE',
  FASHIONUNITED_DE: 'de-DE',
  FASHIONUNITED_ES: 'es-ES',
  FASHIONUNITED_FR: 'fr-FR',
  FASHIONUNITED_IE: 'en-IE',
  FASHIONUNITED_IN: 'en-IN',
  FASHIONUNITED_IT: 'it-IT',
  FASHIONUNITED_MX: 'es-MX',
  FASHIONUNITED_NL: 'nl-NL',
  FASHIONUNITED_NZ: 'en-NZ',
  FASHIONUNITED_UK: 'en-GB',
};

export const executiveLocales = Object.values(executiveLocalesAndNewsboards);

const executiveNewsboards = new Set(Object.keys(executiveLocalesAndNewsboards));

const hasExecutivePage = (
  newsboard: string,
) => executiveNewsboards.has(newsboard);

export default hasExecutivePage;
